import React from 'react';
import DataList from '../DataList';
import ApiConfigFactory from '../../configurations/ApiConfigFactory';

const DoctorList = () => {
    const apiConfig = new ApiConfigFactory(
        'employees/doctors',
        'Doctors',
    );

    apiConfig.path = '/doctor-management';
    apiConfig.allowAdd = true;
    apiConfig.defaultSortFieldId = 'doctor_id';
    apiConfig.defaultSortAsc = true;
    apiConfig.allowExport = true;

    apiConfig
        .addField({ name: 'doctor_id', label: 'Doctor ID', type: 'number', identifier: true, visible: false, tab: 'Main' })
        .addField({ name: 'doctor_name', label: 'Doctor Name', type: 'text', required: true, tab: 'Main' })
        .addField({ name: 'doctor_speciality', label: 'Speciality', type: 'text', required: true, tab: 'Main' })
        .addField({ name: 'bio', label: 'Bio', type: 'textarea', required: false, tab: 'Main' })
        .addField({ name: 'location', label: 'Location', type: 'text', required: false, tab: 'Main' })
        .addField({ name: 'status', label: 'Status', type: 'dropdown', required: true, tab: 'Main', defaultValue: 'Active' })
        .addField({ name: 'item_id', label: 'Zoho Item Mapping', type: 'dropdown', tab: 'Configuration' })
        .addField({ name: 'user_id', label: 'Linked User Account', type: 'dropdown', tab: 'Configuration' });

    apiConfig.addStaticDropdownField({
        name: 'status',
        options: [
            { id: 'Active', name: 'Active' },
            { id: 'Inactive', name: 'Inactive' },
        ],
    });

    apiConfig.addDropdownField({
        name: 'item_id',
        endpoint: '/hospital-portal/api/items',
        valueField: 'item_id',
        labelField: 'item_name',
    });

    apiConfig.addDropdownField({
        name: 'user_id',
        endpoint: '/hospital-portal/api/users',
        valueField: 'id',
        labelField: 'name',
    });

    apiConfig
        .addTab({ name: 'Main', roles: 'all', default: true })
        .addTab({ name: 'Configuration', roles: 'Admin,IT' });

    apiConfig
        .addColumn({ id: 'doctor_id', name: 'ID', selector: (row) => row.doctor_id, type: 'number', sortable: true, identifier: true, width: '75px' })
        .addColumn({ name: 'Name', selector: (row) => row.doctor_name, sortable: true, filterable: true, filterSelector: 'doctor_name' })
        .addColumn({ name: 'Speciality', selector: (row) => row.doctor_speciality, sortable: true, filterable: true, filterSelector: 'doctor_speciality' })
        .addColumn({ name: 'Location', selector: (row) => row.location || '-', sortable: true, filterable: true, filterSelector: 'location' })
        .addColumn({ name: 'Status', selector: (row) => row.status, sortable: true, filterable: true, filterSelector: 'status', width: '100px' })
        .addColumn({ name: 'Zoho Item', selector: (row) => row.Item?.item_name || '-', sortable: true })
        .addColumn({ name: 'Linked User', selector: (row) => row.LinkedUser?.name || '-', sortable: true });

    return <DataList apiConfig={apiConfig} columns={apiConfig.columns} />;
};

export default DoctorList;
